import { Card, Col, Form, Row } from "react-bootstrap";
import { ReactComponent as PaymentMethodImg } from '../../../../Assets/images/payment-icons/payment-card.svg';

const PaymentMethodsSubscription = () => {
    return (<>
        <div className="container-fluid py-3">
            <Card body className="mb-3">
                <Card.Subtitle className="fw-semibold mb-2">Payment Method</Card.Subtitle>
                <Card.Text className="fw-medium mb-2">Current Payment Method </Card.Text>
                <PaymentMethodImg className="img-fluid" width={352} height={220} />
            </Card>
            <Card body>
                <Card.Subtitle className="fw-semibold mb-2">Add Payment Method</Card.Subtitle>
                <Row className="g-3 mt-1">
                    <Col xs={12} sm={6} md={5}>
                        <Form.Group controlId="card-number" className="form-label-group in-border">
                            <Form.Control name="card-number" placeholder="Card Number" defaultValue={'1234 5678 0123 4567'} />
                            <Form.Label>Card Number</Form.Label>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={5}>
                        <Form.Group controlId="expiry-date" className="form-label-group in-border">
                            <Form.Control name="expiry-date" placeholder="Expiry Date" defaultValue={'MM/YY'} />
                            <Form.Label>Expiry Date</Form.Label>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={5}>
                        <Form.Group controlId="security-code" className="form-label-group in-border">
                            <Form.Control name="security-code" placeholder="CVV" defaultValue={'CVV'} />
                            <Form.Label>Security Code</Form.Label>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={5}>
                        <Form.Group controlId="name-on-card" className="form-label-group in-border">
                            <Form.Control name="name-on-card" placeholder="Name On Card" defaultValue={'Name On Card'} />
                            <Form.Label>Name On Card</Form.Label>
                        </Form.Group>
                    </Col>
                    <Col xs={12} className="w-100 mt-0">
                        <Form.Check className="fs-6 text-secondary"
                            type='checkbox'
                            id={`save-card-details-check`}
                            label={`Save Card Details`}
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    </>);
}

export default PaymentMethodsSubscription;